/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowRightFromBracket: {
  name: 'arrow-right-from-bracket';
  data: string;
} = {
  name: 'arrow-right-from-bracket',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h1a1 1 0 1 0 0-2H6V6h1a1 1 0 0 0 0-2H6Zm10.8 3.4a1 1 0 0 0-1.6 1.2L17 11H9a1 1 0 1 0 0 2h8l-1.8 2.4a1 1 0 0 0 1.6 1.2l3-4a1 1 0 0 0 0-1.2l-3-4Z" fill="currentColor"/></svg>`,
};
